import {getTargetQuarter, useTargetQuarterActual, useTargetQuarterGoal} from "../../hooks/kpiHooks";
import {Button} from "primereact/button";

const KPIValueTargetQuarterDisplay = ({target, quarter, selected, setSelectedQuarter}) => {
    const quarterGoal = useTargetQuarterGoal(target, quarter);
    const quarterActual = useTargetQuarterActual(target, quarter);
    const disabled = target?.timeFrame === 'Quarter' && quarter !== getTargetQuarter(target);

    return (<div className={`kpi-value-target-display-quarter ${disabled ? 'disabled' : ''} ${selected ? 'selected' : ''}`}>
        <div className="header"><Button label={`Q${quarter + 1}`} onClick={() => !disabled && setSelectedQuarter(quarter)} /></div>
        <div className="goal">{quarterGoal}</div>
        <div className="actual">{quarterActual}</div>
    </div> )
}

export default KPIValueTargetQuarterDisplay;